import { useEffect, useState } from 'react';
import { Play } from 'lucide-react';
import AcademyNav from '../../components/academy/AcademyNav';
import CtaBand from '../../components/academy/CtaBand';
import Seo from '../../components/academy/Seo';
import BrandHero from '../../components/BrandHero';
import { getVideos } from '../../lib/academyApi';

const AcademyVideos = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    getVideos().then(setVideos).catch(() => {});
  }, []);

  const open = (query) => {
    window.open(`https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`, '_blank', 'noopener');
  };

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #0e0e10 0%, #17171a 55%, #0e0e10 100%)' }}>
      <Seo
        title="Videos"
        description="Watch quick, no-nonsense CarLens Academy walkthroughs on inspecting and buying used cars."
        path="/academy/videos"
        breadcrumbs={[{ name: 'Academy', path: '/academy' }, { name: 'Videos', path: '/academy/videos' }]}
      />
      <BrandHero />
      <AcademyNav />

      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16 space-y-12">
        <div>
          <p className="text-orange-500 text-xs font-bold tracking-[0.25em] uppercase mb-2">Watch & Learn</p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight" style={{ fontFamily: 'Space Grotesk' }}>
            Videos
          </h1>
          <p className="mt-3 text-lg text-zinc-400 max-w-2xl">Short, practical walkthroughs to help you inspect and buy with confidence.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {videos.map((v) => (
            <button
              key={v.id}
              onClick={() => open(v.query)}
              className="group text-left rounded-2xl overflow-hidden bg-[#161618] border border-zinc-800/80 hover:border-zinc-700 transition-all hover:-translate-y-1"
              data-testid={`video-card-${v.id}`}
            >
              <div className="relative aspect-video overflow-hidden">
                <img src={v.thumbnail} alt={v.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
                <span className="absolute inset-0 grid place-items-center">
                  <span className="grid place-items-center w-16 h-16 rounded-full bg-orange-500/90 shadow-xl shadow-orange-500/40 group-hover:scale-110 transition-transform">
                    <Play className="w-7 h-7 text-white fill-white ml-1" />
                  </span>
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-white group-hover:text-orange-400 transition-colors" style={{ fontFamily: 'Space Grotesk' }}>{v.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{v.description}</p>
              </div>
            </button>
          ))}
        </div>

        <CtaBand heading="Prefer a real expert over a video?" sub="Book a CarLens Pre-Purchase Inspection and get a certified evaluation of the exact car you're considering." />
      </div>
    </div>
  );
};

export default AcademyVideos;
